module.exports = __webpack_public_path__ + "static/media/Footbal_Men_Two_Legs_492484_25_A2_Rectangle_80_pattern@2x.337fc99b.png";